/**
 * Aura celebration art for in-app notifications.
 * Served from `public/aura-imagery/` (no spaces — CRA dev server 500s on spaced paths).
 * Source masters live in `public/Aura Imagery/`.
 */
export const NOTIFICATION_AURA_NEW_BEST_DAY_SRC = "/aura-imagery/new-best-day.png";
